<template>
  <div>
    <el-select class="search-el" size="mini" v-model="query.department_id" placeholder="销售部门" v-if="showSelect"
      clearable>
      <el-option label="销售部门" value=""></el-option>
      <el-option v-for="(item, index) in department" :key="index" :label="item" :value="index">
      </el-option>
    </el-select>

    <el-input class="search-el" size="mini" v-model="query.like" placeholder="姓名/昵称/手机号" clearable></el-input>

    <el-select class="search-el" size="mini" v-model="query.status" clearable placeholder="状态">
      <el-option label="全部" value="">全部</el-option>
      <el-option label="在职" value="1">在职</el-option>
      <el-option label="离职" value="0">离职</el-option>
    </el-select>

    <el-button type="primary" size="mini" @click="getList(true)" v-if="showSelect">
      查询
    </el-button>

    <el-button v-if="admin_id == 1" type="primary" size="mini" @click="toAdd()">
      添加
    </el-button>

    <el-button type="info" plain size="mini" @click="openMsg()">使用说明</el-button>

    <el-row>
      <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
        <el-table-column prop="user_id" label="用户ID" align="center" min-width="5%"></el-table-column>
        <el-table-column label="头像" align="center" min-width="10%">
          <template slot-scope="{row}">
            <img :src="row.avatar" style="width:40px" alt="">
          </template>
        </el-table-column>
        <el-table-column label="昵称" align="center" min-width="15%">
          <template slot-scope="{row}">
            <el-link style="color: #67c23a" :underline="false" @click="create(row)">{{ row.nickname }}</el-link>
            <div>{{ row.mobile_phone }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="user_code" label="唯一码" align="center" min-width="8%"></el-table-column>
        <el-table-column prop="department_name" label="部门" align="center" min-width="12%"></el-table-column>
        <el-table-column prop="created_at" label="创建时间" align="center" min-width="12%"></el-table-column>

        <el-table-column label="状态" align="center" min-width="12%">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.status == 1" style="color: #67c23a"><i class="el-icon-circle-check"></i> {{ row.status_msg
                }}</span>
              <span v-else style="color: #909399"><i class="el-icon-circle-close"></i> {{ row.status_msg }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column v-if="is_administrator == 1" label="操作" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button v-if="row.status == 1" type="warning" size="mini"
              @click="changeAttribute(row.id, 'status', 0, row.real_name)">
              解聘
            </el-button>
            <el-button v-if="row.status == 0" type="default" size="mini"
              @click="changeAttribute(row.id, 'status', 1, row.real_name)">
              在职
            </el-button>
            <!-- <el-button v-if="row.status == 0 && row.cleansing_to_user_id == 0" type="danger" size="mini" @click="changeEmployee(row.id)">
              换人
            </el-button> -->
          </template>
        </el-table-column>


      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-row>

    <el-dialog title="编辑" :visible.sync="info.dialogVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" width="50%">
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="部门">
          <el-select class="search-el" size="mini" v-model="info.department_id" clearable>
            <el-option v-for="(item, index) in department" :key="index" :label="item" :value="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="info.real_name" maxlength="8" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="info.dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="createUpdateInfo()" :loading="info.updateLoading">确
            定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import {
  employeeListV2,
  changeAttribute,
  changeEmployee,
  createUpdate
} from "@/api/employee";

export default {
  data: function () {
    return {
      admin_id: this.$route.query.admin_id,
      is_administrator: 0,
      dialogVisible: false,
      list: [],
      department: [],
      loading: false,
      total: 0,
      info: {
        dialogVisible: false,
        updateLoading: false,
        id: 0,
        real_name: "",
        department_id: "请选择部门",
      },
      employeeList: {
        avatar: '',
        id: 0,
        mobile_phone: 0,
        nickname: '',
        user_code: '',
        user_id: 0,
        new_user_num: 0,
        order_num: 0,
        order_amount: 0,
        paid_order_num: 0,
        paid_order_amount: 0,
      },
      rules: {
        mobile_phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ]
      },
      query: {
        page: 1,
        limit: 20,
        mobile_phone: "",
        department_id: "",
        like: "",
        status: "",
      },
      showSelect: false
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    toAdd () {
      if (window.location.host == 'dev.backend.zhangdefenspace.com') {
        window.open('http://dev.admin.defen.hzxinquanzi.com/?c=employee&m=employee_add_staff&p=145', '_blank');
      } else {
        window.open('http://admin.defen.hzxinquanzi.com/?c=employee&m=employee_add_staff&p=145', '_blank');
      }
    },
    getList (str) {
      this.loading = true;
      employeeListV2(this.query).then(response => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.department = response.data.department;
        this.is_administrator = response.data.is_administrator
        if (!str && this.query.department_id) {
          this.showSelect = false
        } else if (!str && !this.query.department_id) {
          this.showSelect = true
        } else if (str) {
          this.showSelect = true
        }
        this.loading = false;
      });
    },

    openMsg () {
      this.$message({
        showClose: true,
        dangerouslyUseHTMLString: true,
        message: '<p>1.点击姓名可以更换员工真实姓名；</p><br/><p>2.点击“解聘”，可以将员工状态设置为“离职”;</p><br/><p>3.点击“换人”，可以将该已离职员工的灵动生活账号复制转移到新员工下。</p>',
        type: 'info',
        duration: 0
      });
    },

    createUpdateInfo () {
      console.log(this.info);
      this.info.updateLoading = true;
      createUpdate({
        id: this.info.id,
        real_name: this.info.real_name,
        department_id: this.info.department_id,
      }).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: "成功",
            type: "success",
          });
          this.info = {
            dialogVisible: false,
            updateLoading: false,
            id: 0,
            real_name: '',
            department_id: '',
          };
          this.getList();
        }
      });
    },

    create (row) {
      console.log(row);
      console.log(this.department);
      this.info = {
        dialogVisible: true,
        updateLoading: false,
        id: row.id,
        real_name: row.real_name,
        department_id: row.department_id.toString(),
      };
    },

    changeRealName (id) {
      this.$prompt("请输入姓名", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        inputPlaceholder: "请输入员工真实姓名"
      }).then(({ value }) => {
        changeAttribute({
          id: id,
          attribute: 'real_name',
          value: value,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    changeAttribute (id, attribute, value, name = '') {
      if (attribute == 'status') {
        let msg = '';
        if (value == 0) {
          msg = '是否确认将"' + name + '"的状态，修改为“离职”？';
        } else {
          msg = '是否确认将“' + name + '”的状态，修改为“在职”？';
        }
        this.$confirm(msg, "状态修改", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          changeAttribute({
            id: id,
            attribute: attribute,
            value: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        }).catch(action => { });
      } else {
        changeAttribute({
          id: id,
          attribute: attribute,
          value: value,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      }

    },

    changeEmployee (id) {
      this.$prompt("此操作将该员工用户复制成新用户，操作不可逆, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        inputPlaceholder: "请输入新员工真实姓名"
      }).then(({ value }) => {
        changeEmployee({
          id: id,
          real_name: value
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted () {
    let str = this.$route.query.department_id;
    this.query.department_id = str;
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>